import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "navigation" }
const _hoisted_2 = { class: "navigation-wrapper" }
const _hoisted_3 = { class: "navigation-split-left nav" }
const _hoisted_4 = { class: "navigation-split-right nav" }
const _hoisted_5 = { class: "justify-content-end" }
const _hoisted_6 = { class: "mr-2" }
const _hoisted_7 = { class: "secondary-font mt-1" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  src: "/public/icons/icon-profil.svg",
  class: "size-base rounded-100 mr-4",
  alt: ""
}
const _hoisted_10 = { class: "navigation-bottom nav2" }
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("nav", _hoisted_3, [
          _createElementVNode("ul", null, [
            _createVNode(_component_router_link, {
              to: "/front",
              class: "text-dark"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createElementVNode("img", {
                  src: "/public/images/logo-wide.svg",
                  class: "logo",
                  alt: "Coop Finance"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _cache[3] || (_cache[3] = _createElementVNode("li", null, [
              _createElementVNode("a", { href: "" }, "Coop")
            ], -1)),
            _cache[4] || (_cache[4] = _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "active",
                href: ""
              }, "Carte")
            ], -1)),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/front/aide" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Aide", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, {
                class: "tag-state lg rounded-50 flex align-items-center gap-2 px-5 py-3",
                to: "/front/market/panier",
                style: {"height":"auto"}
              }, {
                default: _withCtx(() => [
                  _cache[5] || (_cache[5] = _createElementVNode("img", {
                    src: "/public/icons/icon-panier.svg",
                    class: "size-medium",
                    alt: ""
                  }, null, -1)),
                  _createElementVNode("h6", _hoisted_7, "Achat (" + _toDisplayString(_ctx.getTotalItems) + ")", 1),
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "my-badge br2 dot bg-color-1000" }, null, -1))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
                class: "active border-transparent",
                style: {"cursor":"pointer"}
              }, [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" Déconnexion ", -1),
                _createElementVNode("img", {
                  src: "/public/icons/icon-logout.svg",
                  class: "nav-icon",
                  alt: ""
                }, null, -1)
              ]))])
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/front/profil",
                class: "active border-transparent"
              }, {
                default: _withCtx(() => [
                  (_ctx.userAvatar)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.userAvatar,
                        class: "size-base rounded-100 mr-4",
                        alt: ""
                      }, null, 8, _hoisted_8))
                    : (_openBlock(), _createElementBlock("img", _hoisted_9)),
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.userName || 'Mon compte') + " ", 1),
                    _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "font-normal text-xs" }, "Mon compte", -1))
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("img", {
                    src: "/public/icons/icon-go.svg",
                    class: "nav-icon",
                    alt: ""
                  }, null, -1))
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "navigation-main" }, [
          _createElementVNode("h1", { class: "mb-2" }, "Coop Finance"),
          _createElementVNode("p", { class: "" }, "Votre partenaire de confiance pour les solutions financières")
        ], -1)),
        _createElementVNode("nav", _hoisted_10, [
          _createElementVNode("ul", null, [
            (_ctx.isGerant)
              ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                  _createVNode(_component_router_link, { to: "/front/collectivites" }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createElementVNode("img", {
                        src: "/public/icons/icon-collectivite.svg",
                        class: "nav2-icon",
                        alt: ""
                      }, null, -1),
                      _createTextVNode(" Collectivités ", -1)
                    ]))]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/front/wallet" }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-wallet.svg",
                    class: "nav2-icon",
                    alt: ""
                  }, null, -1),
                  _createTextVNode(" Wallet ", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/front/market/portail" }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-market.svg",
                    class: "nav2-icon",
                    alt: ""
                  }, null, -1),
                  _createTextVNode(" Market ", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/front/ma-carte" }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-carte.svg",
                    class: "nav2-icon",
                    alt: ""
                  }, null, -1),
                  _createTextVNode(" Ma Carte ", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/front/budget" }, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-budget.svg",
                    class: "nav2-icon",
                    alt: ""
                  }, null, -1),
                  _createTextVNode(" Budget ", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/front/profil" }, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-profil.svg",
                    class: "nav2-icon",
                    alt: ""
                  }, null, -1),
                  _createTextVNode(" Mon profil ", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view)
    ]),
    _cache[18] || (_cache[18] = _createElementVNode("footer", null, [
      _createElementVNode("p", null, "© 2024 Coop Finance. Tous droits réservés.")
    ], -1))
  ]))
}